interface IInterval {
  label: string;
  start: Date;
  end: Date;
}

const createDate = (negativeDayOffset, setHours: 'dayBegin' | 'dayEnd') => {
  const date = new Date();
  date.setDate(date.getDate() - negativeDayOffset);
  if (setHours === 'dayBegin') {
    date.setHours(0, 0, 0);
  } else if (setHours === 'dayEnd') {
    date.setHours(23, 59, 59);
  }
  return date;
};

export const intervals: IInterval[] = [
  {
    label: 'Today',
    start: createDate(0, 'dayBegin'),
    end: createDate(0, 'dayEnd')
  },
  {
    label: 'Yesterday',
    start: createDate(1, 'dayBegin'),
    end: createDate(1, 'dayEnd')
  },
  {
    // last week (start of "last week" 2 days ago to 7 days ago)
    label: 'Last week',
    start: createDate(7, 'dayBegin'),
    end: createDate(2, 'dayBegin')
  },
  {
    // last month (start of "last month" 7 days ago and before)
    label: 'Last month',
    // Every cards goes in this interval, so we start at 0 (means in 1970)
    start: new Date(0),
    end: createDate(7, 'dayBegin')
  }
];

export const inInterval = (interval: IInterval, date: Date): Boolean => interval.start <= date && date <= interval.end;
